// src/components/TutoringLeadPanel.js
import React, { useMemo, useState } from "react";

export default function TutoringLeadPanel() {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [company, setCompany] = useState(""); // honeypot

  const [sending, setSending] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");

  const meta = useMemo(() => {
    try {
      return {
        pageUrl: window.location?.href || "",
        userAgent: navigator.userAgent || "",
        lang: navigator.language || "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        screen: { w: window.screen?.width, h: window.screen?.height },
        viewport: { w: window.innerWidth, h: window.innerHeight },
        ts: new Date().toISOString(),
      };
    } catch {
      return { ts: new Date().toISOString() };
    }
  }, []);

  function openForm() {
    setErr("");
    setOk(false);
    setFormOpen(true);
  }

  function closeForm() {
    setFormOpen(false);
    setSending(false);
  }

  function reset() {
    setName("");
    setPhone("");
    setEmail("");
    setNote("");
    setCompany("");
    setErr("");
    setOk(false);
  }

  async function submit() {
    setErr("");
    setOk(false);

    const p = String(phone || "").trim();
    if (p.replace(/\s+/g, "").length < 7) {
      setErr("Wpisz poprawny numer telefonu (min. 7 cyfr).");
      return;
    }

    setSending(true);
    try {
      const body = {
        name: String(name || "").trim(),
        phone: p,
        email: String(email || "").trim(),
        note: String(note || "").trim(),
        pageUrl: meta?.pageUrl || "",
        meta,
        company, // honeypot
      };

      const r = await fetch("/api/tutoring-leads", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data?.error || "server_error");

      setOk(true);
      setSending(false);
    } catch (e) {
      console.error(e);
      setErr("Nie udało się wysłać. Spróbuj ponownie.");
      setSending(false);
    }
  }

  return (
    <div
      className="glass-container"
      style={{
        width: "100%",
        padding: "16px 16px",
        borderRadius: "20px",
        boxSizing: "border-box",
        border: "1px solid rgba(255,165,0,0.55)",
      }}
    >
      <style>{`
        .tl-btn{
          border:1px solid rgba(255,165,0,0.65);
          background: transparent;
          color: var(--color-text);
          border-radius: 12px;
          padding: 10px 12px;
          cursor: pointer;
          font-weight: 900;
          white-space: nowrap;
        }
        .tl-btn:hover{ border-color: rgba(255,165,0,0.95); }

        .tl-cardBtn{
          width: 100%;
          text-align: left;
          border: 1px solid rgba(255,165,0,0.0);
          background: transparent;
          color: inherit;
          border-radius: 14px;
          padding: 10px 10px;
          cursor: pointer;
        }
        .tl-cardBtn:hover{
          border-color: rgba(255,165,0,0.35);
          background: rgba(255,165,0,0.04);
        }

        .tl-in{
          width: 100%;
          border:1px solid rgba(255,165,0,0.55);
          background: transparent;
          color: var(--color-text);
          border-radius: 12px;
          padding: 10px 12px;
          font-weight: 700;
          box-sizing: border-box;
        }
        .tl-ta{
          width: 100%;
          min-height: 90px;
          resize: vertical;
          border:1px solid rgba(255,165,0,0.55);
          background: transparent;
          color: var(--color-text);
          border-radius: 12px;
          padding: 10px 12px;
          font-weight: 700;
          box-sizing: border-box;
          line-height: 1.35;
        }

        .tl-muted{ opacity: .82; font-size: 12px; }
        .tl-row{ display:flex; gap:10px; flex-wrap:wrap; }
        .tl-col{ flex: 1 1 240px; min-width: 220px; }
        .tl-ok{ font-weight: 1000; color: rgba(16,185,129,1); }
        .tl-err{ font-weight: 1000; color: rgba(255,165,0,1); }

        .tl-badge{
          display:inline-flex;
          align-items:center;
          gap:6px;
          border:1px solid rgba(255,165,0,0.55);
          border-radius: 999px;
          padding: 4px 10px;
          font-size: 12px;
          font-weight: 900;
          opacity: .95;
          width: fit-content;
        }
        .tl-title{
          font-size: 18px;
          font-weight: 1000;
          line-height: 1.15;
          margin-top: 6px;
        }
        .tl-subtitle{
          font-size: 13px;
          opacity: .92;
          line-height: 1.35;
          margin-top: 6px;
        }
        .tl-mini{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap: 12px;
          flex-wrap: wrap;
        }
        .tl-miniText{
          display:flex;
          flex-direction:column;
          gap: 4px;
          min-width: 240px;
          flex: 1;
        }
        .tl-price{
          margin-top: 8px;
          display:flex;
          gap: 10px;
          flex-wrap: wrap;
          align-items:center;
        }
        .tl-priceTag{
          border:1px solid rgba(255,165,0,0.45);
          border-radius: 999px;
          padding: 4px 10px;
          font-size: 12px;
          font-weight: 900;
          opacity: .95;
        }
          .tl-priceOld{
            opacity: .6;
            text-decoration: line-through;
            text-decoration-thickness: 2px;
            text-decoration-color: rgba(255,165,0,0.75);
          }

          .tl-priceHot{
            border-color: rgba(255,165,0,0.85);
            box-shadow: 0 0 0 1px rgba(255,165,0,0.18) inset;
          }


        .tl-chevron{
          opacity: .85;
          font-weight: 900;
          font-size: 12px;
        }

        /* --- Compact mini banner + floating CTA --- */
        .tl-miniWrap{
          position: relative;
          padding-right: 110px; /* miejsce na przycisk */
        }
        .tl-ctaFloat{
          position: absolute;
          right: 10px;
          bottom: 10px;
        }

        @media (max-width: 520px){
          .tl-title{ font-size: 15px; }
          .tl-subtitle{ font-size: 12px; }
          .tl-miniWrap{ padding-right: 96px; }
          .tl-btn{ padding: 9px 10px; border-radius: 11px; }
          .tl-badge{ padding: 3px 8px; font-size: 11px; }
        }
      `}</style>

      {/* MINI-BANER: marketing + CTA, bez ceny */}
      {!formOpen && (
        <button
          className="tl-cardBtn"
          onClick={() => setDetailsOpen((v) => !v)}
          aria-expanded={detailsOpen ? "true" : "false"}
          title="Kliknij, aby rozwinąć szczegóły"
        >
          <div className="tl-mini tl-miniWrap">
            <div className="tl-miniText">
              <div className="tl-badge">🔥 Ostatnie wolne miejsca</div>

              <div className="tl-title">Chcesz jak najlepiej zdać maturę z matematyki?</div>

              <div className="tl-subtitle">
                Indywidualne korepetycje online + dostęp do Matematron.{" "}
                <span className="tl-chevron">
                  {detailsOpen ? "▲ Zwiń szczegóły" : "▼ Więcej szczegółów"}
                </span>
              </div>
            </div>

            <div className="tl-ctaFloat">
              <button
                className="tl-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  openForm();
                }}
              >
                Zapisz się
              </button>
            </div>
          </div>
        </button>
      )}

      {/* SZCZEGÓŁY (dopiero tu: konkrety + ceny) */}
      {!formOpen && detailsOpen && (
        <div style={{ marginTop: 10 }}>
          <div className="tl-muted" style={{ lineHeight: 1.45 }}>
            Korepetycje prowadzone są zdalnie — na interaktywnej tablicy/notatnicy, z użyciem komunikatora (Teams /
            Discord / link do spotkania bez logowania). Pracujemy na zadaniach maturalnych i Twoich brakach, a
            między zajęciami możesz ćwiczyć na platformie.
          </div>

          <div className="tl-price">
            <span className="tl-priceTag">
              Standardowo: 120 zł / godz.
            </span>

            <span className="tl-priceTag tl-priceHot">
              Pierwsza godzina: <span className="tl-priceOld">120 zł</span> 60 zł • <b>-50%</b>
            </span>
          </div>

          <div className="tl-muted" style={{ marginTop: 8, lineHeight: 1.45 }}>
            Zostaw numer telefonu — skontaktuję się w ciągu <b>48 godzin</b> (SMS lub rozmowa), żeby ustalić
            poziom, cel i terminy.
          </div>
        </div>
      )}

      {/* FORMULARZ */}
      {formOpen && (
        <div style={{ marginTop: 4 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 240 }}>
              <div className="tl-title">Zapis na korepetycje (online)</div>
              <div className="tl-muted" style={{ marginTop: 6 }}>
                Podaj numer telefonu — skontaktuję się w ciągu <b>48 godzin</b>.
              </div>
            </div>

            <button className="tl-btn" onClick={closeForm}>
              Zamknij
            </button>
          </div>

          <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
            <div className="tl-row">
              <div className="tl-col">
                <div className="tl-muted" style={{ marginBottom: 6 }}>
                  Imię (opcjonalnie)
                </div>
                <input
                  className="tl-in"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="np. Ola"
                />
              </div>

              <div className="tl-col">
                <div className="tl-muted" style={{ marginBottom: 6 }}>
                  Telefon (wymagane)
                </div>
                <input
                  className="tl-in"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="np. 501 234 567"
                  inputMode="tel"
                />
              </div>

              <div className="tl-col">
                <div className="tl-muted" style={{ marginBottom: 6 }}>
                  E-mail (opcjonalnie)
                </div>
                <input
                  className="tl-in"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="np. uczen@mail.com"
                  inputMode="email"
                />
              </div>
            </div>

            {/* honeypot */}
            <input
              style={{ display: "none" }}
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              tabIndex={-1}
              autoComplete="off"
            />

            <div>
              <div className="tl-muted" style={{ marginBottom: 6 }}>
                Dodatkowa wiadomość (opcjonalnie)
              </div>
              <textarea
                className="tl-ta"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder={"Np. matura podstawa/rozszerzenie, z czym największy problem, preferowane godziny kontaktu…"}
              />
            </div>

            {err && <div className="tl-err">Błąd: {err}</div>}
            {ok && <div className="tl-ok">Wysłano. Dzięki!</div>}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, flexWrap: "wrap" }}>
              <button className="tl-btn" onClick={reset} disabled={sending}>
                Wyczyść
              </button>
              <button className="tl-btn" onClick={submit} disabled={sending}>
                {sending ? "Wysyłanie..." : "Wyślij"}
              </button>
            </div>

            <div className="tl-muted">Wysyłając formularz zgadzasz się na kontakt w sprawie zajęć.</div>
          </div>
        </div>
      )}
    </div>
  );
}
